import { AbstractDTO } from '../abstract';
import { FormSettingsDTO } from './form-settings';
import { ValidatorFn } from '@angular/forms';
import {FormStepDTO} from './step';
import {FieldControl} from "@signature-it/ngx-generic/enums";
import {FormField} from "./field";

export class FormDTO extends AbstractDTO {
    settings: FormSettingsDTO;
    steps: FormStepDTO[] = [];
	dependValues: object;
	dependValuesRules: object;
    validatorFn: ValidatorFn[];

    constructor(attributes?: Object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.settings = FormSettingsDTO.create(attributes['settings']);
        this.steps = FormStepDTO.createFromArray(attributes['steps']);
        this.dependValues = attributes['dependValues'] || {};
        this.dependValuesRules = attributes['dependValuesRules'] || {};
    }

    setValidatorFn(fnc: ValidatorFn[]) {
        this.validatorFn = fnc;
    }

    setValues(values, force: boolean = false) {
        this.steps.forEach(step => {
            step.setValues(values, force);
        })
    }

    getFields() {
		const fields = this.getStepFields(this.steps, []);
        return fields;
    }

    getRegularFields() {
       const  excludedControlTypes = new Set([
           FieldControl.MAIN_SEPARATOR,
           FieldControl.SUB_SEPARATOR,
       ]);
        return this.steps?.flatMap(step => step.fields)
            .filter(({ key, controlType }: FormField) =>
                key && !key.endsWith('is_valid') && !excludedControlTypes.has(controlType as FieldControl)
        );
    }

    getStepFields(steps: FormStepDTO[], fields) {
		steps.forEach((step: FormStepDTO) => {
		    if(step.steps) {
				fields = this.getStepFields(step.steps, fields);
            } else {
                if(step.fields) {
                    fields = fields.concat(step.fields);
                }
            }
		});
		return fields;
    }

	getRealFields() {
        return this.getFields().filter(field => !field.isHelper);
    }

}
